import {
  BrowserEnvironmentResult,
  BrowserValidator,
} from "@/utils/security/browser-environment-validator";

/**
 * 브라우저 환경(지원 브라우저 여부) 체크 유스케이스
 */
export class BrowserEnvironmentCheckUsecase {
  constructor(
    private readonly isValidBrowser: () => BrowserEnvironmentResult = () =>
      BrowserValidator.isValidBrowser()
  ) {}

  execute(): BrowserEnvironmentResult {
    return this.isValidBrowser();
  }
}

